import React from 'react'
import Firebase from 'firebase/app'

import updatePerson from '../../actions/updatePerson'
import {
  AppAction,
} from '../../styles/links'

const PhoneChanger = ({person}) => (
  <span>
    <ion-icon name="call" className="small"></ion-icon>
    <AppAction onClick={ () => {
      const newPhone = window.prompt(`${person.name}'s phone number`, person.phone)
      if (newPhone) {
        updatePerson(person.id, {phone: newPhone})
      }
    }}>
      {person.phone || 'add phone number'}
    </AppAction>
    {' '}
    {person.phone &&
      <AppAction onClick={ () => updatePerson(person.id, {phone: Firebase.firestore.FieldValue.delete()})}>
        remove
      </AppAction>
    }
  </span>
)

export default PhoneChanger



// WEBPACK FOOTER //
// ./src/views/person/PhoneChanger.js